import AssistantActions from "./assistantActions";

const initialState = {
  list: null,
  listCounter: 0,
  assistant: null,
};

const assistantReducer = (state = initialState, action) => {
  switch (action.type) {
    case AssistantActions.LOADED_LIST:
      return {
        ...state,
        list: action.list,
      };
    case AssistantActions.LOADED_ASSISTANT:
      return {
        ...state,
        assistant: action.assistant,
      };
    case AssistantActions.CREATED_ASSISTANT:
      return {
        ...state,
        listCounter: state.listCounter + 1,
      };
    case AssistantActions.UPDATED_ASSISTANT:
      return {
        ...state,
        assistant: action.assistant,
        listCounter: state.listCounter + 1,
      };
    case AssistantActions.DELETED_ASSISTANT:
      return {
        ...state,
        listCounter: state.listCounter + 1,
      };
    default:
      return state;
  }
};

export const assistantSelectors = {
  getList: (state) => state.assistants.list,
  getListCounter: (state) => state.assistants.listCounter,
  getAssistant: (state) => state.assistants.assistant,
};

export default assistantReducer;
